import { asset } from "@/lib/asset";
import { useState } from 'react';

const videoBlocks = [
    {
        id: 1,
        video: "/static/videos/banks.mp4",
        poster: "banks.png",
        title: "Банки",
        text: "От инфраструктуры до KPI",
        modalId: "modal-banks"
    },
    {
        id: 2,
        video: "/static/videos/companies.mp4",
        poster: "companies.png",
        title: "Предприятия",
        text: "Разработка и контроль продуктов",
        modalId: "modal-companies"
    },
    {
        id: 3,
        video: "/static/videos/outsourcing.mp4",
        poster: "it-outsourcing.png",
        title: "ИТ-аутсорсинг",
        text: "Контроль качества разработки",
        modalId: "modal-outsourcing"
    },
    {
        id: 4,
        video: "/static/videos/tek.mp4",
        poster: "tek.png",
        title: "ТЭК",
        text: "Анализ ERP-систем",
        modalId: "modal-tek"
    }
];

export default function HomeAPMInstructions() {
    const [activeModal, setActiveModal] = useState(null);

    const openModal = (modalId) => {
        setActiveModal(modalId);
    };

    const closeModal = () => {
        setActiveModal(null);
    };

    return (
        <div className="container mx-auto bg-main">
            <div className="py-3 lg:py-3 bg-relative">
                <div className="flex flex-col justify-center items-center mb-3 lg:mb-3 py-4 lg:py-5">
                    
                    {/* Title Section */}
                    <div className="w-full text-center mt-1 lg:mt-4 mb-[60px] lg:mb-[50px]">
                        <div className="lg:text-center text-[20px] xl:text-3xl font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text mb-[60px]">
                            Инструкции по APM применению
                        </div>
                    </div>

                    {/* Video Blocks Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 lg:gap-6 max-w-[320px] md:max-w-full lg:max-w-[1200px]">
                        {videoBlocks.map((block) => (
                            <div key={block.id} className="flex flex-col items-center text-center w-[285px] mx-[10px]">
                                {/* Video Thumbnail */}
                                <button
                                    onClick={() => openModal(block.modalId)}
                                    className="relative w-[285px] h-[310px] bg-cover bg-center bg-no-repeat cursor-pointer group"
                                    style={{
                                        backgroundImage: `url(/img/bgs/${block.poster})`
                                    }}
                                >
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <img 
                                            className="w-[100px] h-[100px] group-hover:scale-110 transition-transform duration-300" 
                                            src={asset("/img/icons/play-video.png")} 
                                            alt="Play video"
                                        />
                                    </div>
                                </button>

                                {/* Text Content */}
                                <div className="mt-[40px] md:mt-[45px] mb-[50px] flex flex-col items-center justify-center text-center">
                                    <div className={`text-[18px] lg:text-[24px] w-full text-left font-bold bg-clip-text text-[#d3aa86]  mb-[10px] text-center`}>
                                        {block.title}
                                    </div>
                                    <div className="text-[14px] lg:text-[16px] text-gray-600 w-full text-center">
                                        {block.text}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Modal */}
            {activeModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden">
                        <div className="flex justify-between items-center p-4 border-b">
                            <h3 className="text-lg font-semibold">
                                {videoBlocks.find(block => block.modalId === activeModal)?.title}
                            </h3>
                            <button
                                onClick={closeModal}
                                className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                            >
                                ×
                            </button>
                        </div>
                        <div className="p-4">
                            <video
                                width="100%"
                                height="400"
                                controls
                                src={videoBlocks.find(block => block.modalId === activeModal)?.video}
                                className="w-full"
                            >
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
